/* eslint-disable max-lines */
import gql from 'graphql-tag';
import * as Urql from 'urql';

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const LoginWithEmailDocument = gql`
  mutation loginWithEmail($email: String!, $verificationCode: String!) {
    loginWithEmail(email: $email, verificationCode: $verificationCode) {
      accessToken
      refreshToken
      expiresIn
    }
  }
`;

export const useLoginWithEmailMutation = () =>
  Urql.useMutation<LoginWithEmailMutation, LoginWithEmailMutationVariables>(
    LoginWithEmailDocument,
  );
export const LoginWithPasswordDocument = gql`
  mutation loginWithPassword($email: String!, $password: String!) {
    loginWithPassword(email: $email, password: $password) {
      accessToken
      refreshToken
      expiresIn
    }
  }
`;

export const useLoginWithPasswordMutation = () =>
  Urql.useMutation<
    LoginWithPasswordMutation,
    LoginWithPasswordMutationVariables
  >(LoginWithPasswordDocument);
export const RequestEmailVerificationCodeDocument = gql`
  mutation requestEmailVerificationCode($email: String!) {
    requestEmailVerificationCode(email: $email) {
      expiresIn
    }
  }
`;

export const useRequestEmailVerificationCodeMutation = () =>
  Urql.useMutation<
    RequestEmailVerificationCodeMutation,
    RequestEmailVerificationCodeMutationVariables
  >(RequestEmailVerificationCodeDocument);
export const RefreshTokenDocument = gql`
  mutation refreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      expiresIn
    }
  }
`;

export const useRefreshTokenMutation = () =>
  Urql.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
    RefreshTokenDocument,
  );
export const CreateGameMatchPositionDocument = gql`
  mutation CreateGameMatchPosition(
    $createGameInput: CreateGameMatchPositionInput!
  ) {
    createGameMatchPosition(createGameInput: $createGameInput) {
      id
      createdAt
      gameMatchID
      quoteToken
      entryPrice
      participant {
        currency
        vBalance
        match {
          id
        }
        user {
          nickName
          avatar
        }
      }
      liquidationPrice
      size
      profit
      expiredAt
      openedAt
      closedAt
      targetPoint
      stopLoss
      match {
        id
        status
        startTime
        endTime
      }
    }
  }
`;

export const useCreateGameMatchPositionMutation = () =>
  Urql.useMutation<
    CreateGameMatchPositionMutation,
    CreateGameMatchPositionMutationVariables
  >(CreateGameMatchPositionDocument);
export const CancelGameMatchPositionDocument = gql`
  mutation CancelGameMatchPosition($id: ID!) {
    cancelGameMatchPosition(id: $id)
  }
`;

export const useCancelGameMatchPositionMutation = () =>
  Urql.useMutation<
    CancelGameMatchPositionMutation,
    CancelGameMatchPositionMutationVariables
  >(CancelGameMatchPositionDocument);
export const CloseGameMatchPositionDocument = gql`
  mutation closeGameMatchPosition($id: ID!, $percentage: Float!) {
    closeGameMatchPosition(id: $id, percentage: $percentage) {
      id
    }
  }
`;

export const useCloseGameMatchPositionMutation = () =>
  Urql.useMutation<
    CloseGameMatchPositionMutation,
    CloseGameMatchPositionMutationVariables
  >(CloseGameMatchPositionDocument);
export const JoinToGameDocument = gql`
  mutation joinToGame($id: ID!) {
    joinGame(id: $id)
  }
`;

export const useJoinToGameMutation = () =>
  Urql.useMutation<JoinToGameMutation, JoinToGameMutationVariables>(
    JoinToGameDocument,
  );
export const UpdateProfileDocument = gql`
  mutation updateProfile($updateProfileInput: UpdateProfileInput!) {
    updateProfile(updateProfileInput: $updateProfileInput) {
      id
    }
  }
`;

export const useUpdateProfileMutation = () =>
  Urql.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(
    UpdateProfileDocument,
  );
export const CreateWalletDocument = gql`
  mutation CreateWallet($createWalletInput: CreateWalletInput!) {
    createWallet(createWalletInput: $createWalletInput) {
      id
      createdAt
      updatedAt
      currency
      userID
      balance
      locked
      address
    }
  }
`;

export const useCreateWalletMutation = () =>
  Urql.useMutation<CreateWalletMutation, CreateWalletMutationVariables>(
    CreateWalletDocument,
  );
export const CreateWithdrawRequestDocument = gql`
  mutation CreateWithdrawRequest(
    $createWithdrawalInput: CreateWithdrawalInput!
  ) {
    createWithdrawRequest(createWithdrawalInput: $createWithdrawalInput) {
      id
      updatedAt
      createdAt
      amount
      balanceAfterTransaction
      type
      description
      ref
      status
      walletID
    }
  }
`;

export const useCreateWithdrawRequestMutation = () =>
  Urql.useMutation<
    CreateWithdrawRequestMutation,
    CreateWithdrawRequestMutationVariables
  >(CreateWithdrawRequestDocument);
export const GetAchievementsDocument = gql`
  query getAchievements {
    achievements {
      edges {
        node {
          id
          name
          description
          avatar
          createdAt
          updatedAt
          expiresAt
          isHidden
          isActive
          key
          rewards {
            id
            createdAt
            updatedAt
            name
            description
            avatar
            value
            type
          }
          rules {
            id
            createdAt
            updatedAt
            field
            comparator
            weight
            target
          }
        }
      }
    }
  }
`;

export const useGetAchievementsQuery = (
  options?: Omit<Urql.UseQueryArgs<GetAchievementsQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetAchievementsQuery, GetAchievementsQueryVariables>({
    query: GetAchievementsDocument,
    ...options,
  });
export const GetAssetsDocument = gql`
  query getAssets {
    assets {
      id
      name
      priceUSD
      iconUrl
      volumeUSD24Hr
    }
  }
`;

export const useGetAssetsQuery = (
  options?: Omit<Urql.UseQueryArgs<GetAssetsQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetAssetsQuery, GetAssetsQueryVariables>({
    query: GetAssetsDocument,
    ...options,
  });
export const AssetsDocument = gql`
  subscription assets {
    assetsUpdated {
      id
      priceUSD
    }
  }
`;

export const useAssetsSubscription = <TData = AssetsSubscription>(
  options?: Omit<
    Urql.UseSubscriptionArgs<AssetsSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<AssetsSubscription, TData>,
) =>
  Urql.useSubscription<AssetsSubscription, TData, AssetsSubscriptionVariables>(
    {query: AssetsDocument, ...options},
    handler,
  );
export const GetActiveGamesLimitedDocument = gql`
  query GetActiveGamesLimited {
    games(first: 3, filterBy: {isActive: true, q: ""}) {
      edges {
        node {
          id
          createdAt
          currency
          title
          description
          isActive
          duration
          maxPlayers
          cover
          maxPlayers
          startVBalance
          minPlayers
          entryFee
          minPlayers
          winExp
          loseExp
          cup
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

export const useGetActiveGamesLimitedQuery = (
  options?: Omit<
    Urql.UseQueryArgs<GetActiveGamesLimitedQueryVariables>,
    'query'
  >,
) =>
  Urql.useQuery<
    GetActiveGamesLimitedQuery,
    GetActiveGamesLimitedQueryVariables
  >({query: GetActiveGamesLimitedDocument, ...options});
export const GetDetailsGameDocument = gql`
  query GetDetailsGame($id: ID!) {
    game(id: $id) {
      id
      createdAt
      currency
      title
      description
      isActive
      duration
      maxPlayers
      cover
      maxPlayers
      startVBalance
      minPlayers
      entryFee
      minPlayers
      winExp
      loseExp
      cup
    }
  }
`;

export const useGetDetailsGameQuery = (
  options: Omit<Urql.UseQueryArgs<GetDetailsGameQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetDetailsGameQuery, GetDetailsGameQueryVariables>({
    query: GetDetailsGameDocument,
    ...options,
  });
export const GetMatchsDocument = gql`
  query getMatchs {
    profile {
      matches {
        edges {
          node {
            positions {
              gameMatchID
              status
              id
              createdAt
              updatedAt
              gameMatchParticipantID
              baseToken
              quoteToken
              entryPrice
              size
              profit
              side
              expiredAt
              targetPoint
              participant {
                currency
              }
              closedAt
              openedAt
              stopLoss
            }
            match {
              id
              status
              startTime
              endTime
              winner {
                nickName
              }
              game {
                startVBalance
                title
                duration
              }
              participants {
                vBalance
                currency
                positions {
                  id
                  createdAt
                  gameMatchID
                  quoteToken
                  entryPrice
                  side
                  participant {
                    currency
                    vBalance
                    match {
                      id
                    }
                    user {
                      nickName
                      avatar
                    }
                  }
                  liquidationPrice
                  size
                  profit
                  expiredAt
                  openedAt
                  closedAt
                  targetPoint
                  stopLoss
                  match {
                    id
                    status
                    startTime
                    endTime
                  }
                }
                user {
                  nickName
                  avatar
                  id
                  wallets {
                    balance
                    currency
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const useGetMatchsQuery = (
  options?: Omit<Urql.UseQueryArgs<GetMatchsQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetMatchsQuery, GetMatchsQueryVariables>({
    query: GetMatchsDocument,
    ...options,
  });
export const GetOneMatchDocument = gql`
  query getOneMatch($where: GameMatchParticipantWhereInput!) {
    profile {
      matches(where: $where) {
        edges {
          node {
            positions {
              gameMatchID
              status
              id
              createdAt
              updatedAt
              gameMatchParticipantID
              baseToken
              quoteToken
              entryPrice
              size
              profit
              side
              expiredAt
              targetPoint
              participant {
                currency
              }
              closedAt
              openedAt
              stopLoss
            }
            match {
              id
              status
              startTime
              endTime
              winner {
                nickName
              }
              game {
                startVBalance
                title
                duration
              }
              participants {
                vBalance
                currency
                positions {
                  id
                  createdAt
                  gameMatchID
                  quoteToken
                  entryPrice
                  side
                  participant {
                    currency
                    vBalance
                    match {
                      id
                    }
                    user {
                      nickName
                      avatar
                      level
                    }
                  }
                  liquidationPrice
                  size
                  profit
                  expiredAt
                  openedAt
                  closedAt
                  targetPoint
                  stopLoss
                  match {
                    id
                    status
                    startTime
                    endTime
                  }
                }
                user {
                  nickName
                  avatar
                  id
                  level
                  wallets {
                    balance
                    currency
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const useGetOneMatchQuery = (
  options: Omit<Urql.UseQueryArgs<GetOneMatchQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetOneMatchQuery, GetOneMatchQueryVariables>({
    query: GetOneMatchDocument,
    ...options,
  });
export const GetProfileDocument = gql`
  query getProfile {
    profile {
      id
      createdAt
      updatedAt
      isActive
      email
      nickName
      avatar
      cup
      exp
      isSuperuser
      isStaff
      achievements {
        edges {
          node {
            id
            createdAt
            updatedAt
            userID
            achievementID
            progress
            isCompleted
            completedAt
          }
        }
      }
      wallets {
        id
        currency
        balance
        locked
        createdAt
        updatedAt
        address
      }
    }
  }
`;

export const useGetProfileQuery = (
  options?: Omit<Urql.UseQueryArgs<GetProfileQueryVariables>, 'query'>,
) =>
  Urql.useQuery<GetProfileQuery, GetProfileQueryVariables>({
    query: GetProfileDocument,
    ...options,
  });
export const PositionsDocument = gql`
  query positions {
    gameMatchPositions {
      edges {
        node {
          id
          createdAt
          updatedAt
          gameMatchID
          gameMatchParticipantID
          entryPrice
          closePrice
          margin
          leverage
          side
          type
          status
          stopLoss
          targetPoint
          profit
          expiredAt
          openedAt
          closedAt
          quoteToken
        }
      }
      totalCount
    }
  }
`;

export const usePositionsQuery = (
  options?: Omit<Urql.UseQueryArgs<PositionsQueryVariables>, 'query'>,
) =>
  Urql.useQuery<PositionsQuery, PositionsQueryVariables>({
    query: PositionsDocument,
    ...options,
  });
export const GetAssetsUpdatedDocument = gql`
  subscription GetAssetsUpdated {
    assetsUpdated {
      id
      priceUSD
    }
  }
`;

export const useGetAssetsUpdatedSubscription = <
  TData = GetAssetsUpdatedSubscription,
>(
  options?: Omit<
    Urql.UseSubscriptionArgs<GetAssetsUpdatedSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<GetAssetsUpdatedSubscription, TData>,
) =>
  Urql.useSubscription<
    GetAssetsUpdatedSubscription,
    TData,
    GetAssetsUpdatedSubscriptionVariables
  >({query: GetAssetsUpdatedDocument, ...options}, handler);
export const GetNotificationGlobalDocument = gql`
  subscription GetNotificationGlobal {
    NotificationGlobal {
      target
      id
      message
      createdAt
      action
      type
      event
      data
    }
  }
`;

export const useGetNotificationGlobalSubscription = <
  TData = GetNotificationGlobalSubscription,
>(
  options?: Omit<
    Urql.UseSubscriptionArgs<GetNotificationGlobalSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<GetNotificationGlobalSubscription, TData>,
) =>
  Urql.useSubscription<
    GetNotificationGlobalSubscription,
    TData,
    GetNotificationGlobalSubscriptionVariables
  >({query: GetNotificationGlobalDocument, ...options}, handler);
export const GetNotificationMatchDocument = gql`
  subscription GetNotificationMatch($matchId: ID!) {
    NotificationMatch(matchId: $matchId) {
      target
      id
      message
      createdAt
      action
      type
      event
      data
    }
  }
`;

export const useGetNotificationMatchSubscription = <
  TData = GetNotificationMatchSubscription,
>(
  options: Omit<
    Urql.UseSubscriptionArgs<GetNotificationMatchSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<GetNotificationMatchSubscription, TData>,
) =>
  Urql.useSubscription<
    GetNotificationMatchSubscription,
    TData,
    GetNotificationMatchSubscriptionVariables
  >({query: GetNotificationMatchDocument, ...options}, handler);
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: {input: string; output: string};
  String: {input: string; output: string};
  Boolean: {input: boolean; output: boolean};
  Int: {input: number; output: number};
  Float: {input: number; output: number};
  Cursor: {input: any; output: any};
  Duration: {input: any; output: any};
  Int64: {input: any; output: any};
  JSON: {input: any; output: any};
  Time: {input: any; output: any};
  UUID: {input: any; output: any};
  Uint8: {input: any; output: any};
  Uint64: {input: any; output: any};
  Upload: {input: any; output: any};
  _Any: {input: any; output: any};
  _FieldSet: {input: any; output: any};
};

export type Achievement = Node & {
  __typename?: 'Achievement';
  avatar: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rewards?: Maybe<Array<Consumable>>;
  rules?: Maybe<Array<AchievementRule>>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type AchievementConnection = {
  __typename?: 'AchievementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AchievementEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AchievementEdge = {
  __typename?: 'AchievementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Achievement>;
};

export type AchievementFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for Achievement connections */
export type AchievementOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Achievements. */
  field: AchievementOrderField;
};

/** Properties by which Achievement connections can be ordered. */
export enum AchievementOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type AchievementRule = Node & {
  __typename?: 'AchievementRule';
  comparator: AchievementRuleComparator;
  createdAt: Scalars['Time']['output'];
  field: AchievementRuleField;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  target: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  weight: Scalars['Float']['output'];
};

/** AchievementRuleComparator is enum for the field comparator */
export enum AchievementRuleComparator {
  Bool = 'bool',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
}

/** A connection to a list of items. */
export type AchievementRuleConnection = {
  __typename?: 'AchievementRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AchievementRuleEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AchievementRuleEdge = {
  __typename?: 'AchievementRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AchievementRule>;
};

/** AchievementRuleField is enum for the field field */
export enum AchievementRuleField {
  Invite = 'invite',
  Level = 'level',
  Losses = 'losses',
  Matches = 'matches',
  Positions = 'positions',
  TotalProfit = 'total_profit',
  TotalVolume = 'total_volume',
  Wins = 'wins',
  WinsInRow = 'wins_in_row',
}

export type AchievementRuleFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for AchievementRule connections */
export type AchievementRuleOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order AchievementRules. */
  field: AchievementRuleOrderField;
};

/** Properties by which AchievementRule connections can be ordered. */
export enum AchievementRuleOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * AchievementRuleWhereInput is used for filtering AchievementRule objects.
 * Input was generated by ent.
 */
export type AchievementRuleWhereInput = {
  and?: InputMaybe<Array<AchievementRuleWhereInput>>;
  /** comparator field predicates */
  comparator?: InputMaybe<AchievementRuleComparator>;
  comparatorIn?: InputMaybe<Array<AchievementRuleComparator>>;
  comparatorNEQ?: InputMaybe<AchievementRuleComparator>;
  comparatorNotIn?: InputMaybe<Array<AchievementRuleComparator>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** field field predicates */
  field?: InputMaybe<AchievementRuleField>;
  fieldIn?: InputMaybe<Array<AchievementRuleField>>;
  fieldNEQ?: InputMaybe<AchievementRuleField>;
  fieldNotIn?: InputMaybe<Array<AchievementRuleField>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AchievementRuleWhereInput>;
  or?: InputMaybe<Array<AchievementRuleWhereInput>>;
  /** target field predicates */
  target?: InputMaybe<Scalars['Float']['input']>;
  targetGT?: InputMaybe<Scalars['Float']['input']>;
  targetGTE?: InputMaybe<Scalars['Float']['input']>;
  targetIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  targetLT?: InputMaybe<Scalars['Float']['input']>;
  targetLTE?: InputMaybe<Scalars['Float']['input']>;
  targetNEQ?: InputMaybe<Scalars['Float']['input']>;
  targetNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** weight field predicates */
  weight?: InputMaybe<Scalars['Float']['input']>;
  weightGT?: InputMaybe<Scalars['Float']['input']>;
  weightGTE?: InputMaybe<Scalars['Float']['input']>;
  weightIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  weightLT?: InputMaybe<Scalars['Float']['input']>;
  weightLTE?: InputMaybe<Scalars['Float']['input']>;
  weightNEQ?: InputMaybe<Scalars['Float']['input']>;
  weightNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type AchievementRulesPage = {
  __typename?: 'AchievementRulesPage';
  data?: Maybe<Array<AchievementRule>>;
  total: Scalars['Int']['output'];
};

/**
 * AchievementWhereInput is used for filtering Achievement objects.
 * Input was generated by ent.
 */
export type AchievementWhereInput = {
  and?: InputMaybe<Array<AchievementWhereInput>>;
  /** avatar field predicates */
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarContains?: InputMaybe<Scalars['String']['input']>;
  avatarContainsFold?: InputMaybe<Scalars['String']['input']>;
  avatarEqualFold?: InputMaybe<Scalars['String']['input']>;
  avatarGT?: InputMaybe<Scalars['String']['input']>;
  avatarGTE?: InputMaybe<Scalars['String']['input']>;
  avatarHasPrefix?: InputMaybe<Scalars['String']['input']>;
  avatarHasSuffix?: InputMaybe<Scalars['String']['input']>;
  avatarIn?: InputMaybe<Array<Scalars['String']['input']>>;
  avatarLT?: InputMaybe<Scalars['String']['input']>;
  avatarLTE?: InputMaybe<Scalars['String']['input']>;
  avatarNEQ?: InputMaybe<Scalars['String']['input']>;
  avatarNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** expires_at field predicates */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiresAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiresAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiresAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** rewards edge predicates */
  hasRewards?: InputMaybe<Scalars['Boolean']['input']>;
  hasRewardsWith?: InputMaybe<Array<ConsumableWhereInput>>;
  /** rules edge predicates */
  hasRules?: InputMaybe<Scalars['Boolean']['input']>;
  hasRulesWith?: InputMaybe<Array<AchievementRuleWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_hidden field predicates */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isHiddenNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** key field predicates */
  key?: InputMaybe<Scalars['String']['input']>;
  keyContains?: InputMaybe<Scalars['String']['input']>;
  keyContainsFold?: InputMaybe<Scalars['String']['input']>;
  keyEqualFold?: InputMaybe<Scalars['String']['input']>;
  keyGT?: InputMaybe<Scalars['String']['input']>;
  keyGTE?: InputMaybe<Scalars['String']['input']>;
  keyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  keyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  keyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  keyLT?: InputMaybe<Scalars['String']['input']>;
  keyLTE?: InputMaybe<Scalars['String']['input']>;
  keyNEQ?: InputMaybe<Scalars['String']['input']>;
  keyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<AchievementWhereInput>;
  or?: InputMaybe<Array<AchievementWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type AchievementsPage = {
  __typename?: 'AchievementsPage';
  data?: Maybe<Array<Achievement>>;
  total: Scalars['Int']['output'];
};

export type Asset = {
  __typename?: 'Asset';
  /** The direction and value change in the last 24 hours */
  changePercent24Hr: Scalars['Float']['output'];
  /** Asset icon URL */
  iconUrl: Scalars['String']['output'];
  /** unique identifier for asset */
  id: Scalars['String']['output'];
  /** supply x price */
  marketCapUSD: Scalars['Float']['output'];
  /** total quantity of asset issued */
  maxSupply: Scalars['Float']['output'];
  /** proper name for asset */
  name: Scalars['String']['output'];
  /** volume-weighted price based on real-time market data, translated to USD */
  priceUSD: Scalars['Float']['output'];
  /** rank is in ascending order - this number is directly associated with the marketcap whereas the highest marketcap receives rank 1 */
  rank: Scalars['Int']['output'];
  /** available supply for trading */
  supply: Scalars['Float']['output'];
  /** most common symbol used to identify this asset on an exchange */
  symbol: Scalars['String']['output'];
  /** quantity of trading volume represented in USD over the last 24 hours */
  volumeUSD24Hr: Scalars['Float']['output'];
  /** Volume Weighted Average Price in the last 24 hours */
  vwap24Hr: Scalars['Float']['output'];
};

export type AssetUpdate = {
  __typename?: 'AssetUpdate';
  id: Scalars['String']['output'];
  priceUSD: Scalars['Float']['output'];
};

export type Consumable = Node & {
  __typename?: 'Consumable';
  avatar: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: ConsumableType;
  updatedAt: Scalars['Time']['output'];
  value: Scalars['Uint64']['output'];
};

/** A connection to a list of items. */
export type ConsumableConnection = {
  __typename?: 'ConsumableConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ConsumableEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ConsumableEdge = {
  __typename?: 'ConsumableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Consumable>;
};

export type ConsumableFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for Consumable connections */
export type ConsumableOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Consumables. */
  field: ConsumableOrderField;
};

/** Properties by which Consumable connections can be ordered. */
export enum ConsumableOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** ConsumableType is enum for the field type */
export enum ConsumableType {
  Avatar = 'avatar',
  Exp = 'exp',
  Leverage = 'leverage',
  VBalance = 'v_balance',
}

/**
 * ConsumableWhereInput is used for filtering Consumable objects.
 * Input was generated by ent.
 */
export type ConsumableWhereInput = {
  and?: InputMaybe<Array<ConsumableWhereInput>>;
  /** avatar field predicates */
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarContains?: InputMaybe<Scalars['String']['input']>;
  avatarContainsFold?: InputMaybe<Scalars['String']['input']>;
  avatarEqualFold?: InputMaybe<Scalars['String']['input']>;
  avatarGT?: InputMaybe<Scalars['String']['input']>;
  avatarGTE?: InputMaybe<Scalars['String']['input']>;
  avatarHasPrefix?: InputMaybe<Scalars['String']['input']>;
  avatarHasSuffix?: InputMaybe<Scalars['String']['input']>;
  avatarIn?: InputMaybe<Array<Scalars['String']['input']>>;
  avatarLT?: InputMaybe<Scalars['String']['input']>;
  avatarLTE?: InputMaybe<Scalars['String']['input']>;
  avatarNEQ?: InputMaybe<Scalars['String']['input']>;
  avatarNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<ConsumableWhereInput>;
  or?: InputMaybe<Array<ConsumableWhereInput>>;
  /** type field predicates */
  type?: InputMaybe<ConsumableType>;
  typeIn?: InputMaybe<Array<ConsumableType>>;
  typeNEQ?: InputMaybe<ConsumableType>;
  typeNotIn?: InputMaybe<Array<ConsumableType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** value field predicates */
  value?: InputMaybe<Scalars['Uint64']['input']>;
  valueGT?: InputMaybe<Scalars['Uint64']['input']>;
  valueGTE?: InputMaybe<Scalars['Uint64']['input']>;
  valueIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  valueLT?: InputMaybe<Scalars['Uint64']['input']>;
  valueLTE?: InputMaybe<Scalars['Uint64']['input']>;
  valueNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  valueNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
};

export type ConsumablesPage = {
  __typename?: 'ConsumablesPage';
  data?: Maybe<Array<Consumable>>;
  total: Scalars['Int']['output'];
};

/**
 * CreateAchievementInput is used for create Achievement object.
 * Input was generated by ent.
 */
export type CreateAchievementInput = {
  avatar: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
  rewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ruleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateAchievementRuleInput is used for create AchievementRule object.
 * Input was generated by ent.
 */
export type CreateAchievementRuleInput = {
  comparator?: InputMaybe<AchievementRuleComparator>;
  field: AchievementRuleField;
  name: Scalars['String']['input'];
  target: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
};

/**
 * CreateConsumableInput is used for create Consumable object.
 * Input was generated by ent.
 */
export type CreateConsumableInput = {
  avatar: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: ConsumableType;
  value?: InputMaybe<Scalars['Uint64']['input']>;
};

/**
 * CreateGameInput is used for create Game object.
 * Input was generated by ent.
 */
export type CreateGameInput = {
  cover: Scalars['String']['input'];
  cup?: InputMaybe<Scalars['Uint64']['input']>;
  currency: GameCurrency;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Duration']['input']>;
  entryFee?: InputMaybe<Scalars['Uint64']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loseExp?: InputMaybe<Scalars['Uint64']['input']>;
  maxPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositions?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  rewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rewardPrice?: InputMaybe<Scalars['Uint64']['input']>;
  startVBalance?: InputMaybe<Scalars['Float']['input']>;
  title: Scalars['String']['input'];
  winExp?: InputMaybe<Scalars['Uint64']['input']>;
};

/**
 * CreateGameMatchPositionInput is used for create GameMatchPosition object.
 * Input was generated by ent.
 */
export type CreateGameMatchPositionInput = {
  baseToken: Scalars['String']['input'];
  entryPrice: Scalars['Float']['input'];
  leverage: Scalars['Uint8']['input'];
  leverageID?: InputMaybe<Scalars['UUID']['input']>;
  margin: Scalars['Float']['input'];
  matchID: Scalars['ID']['input'];
  side: GameMatchPositionSide;
  stopLoss?: InputMaybe<Scalars['Float']['input']>;
  targetPoint?: InputMaybe<Scalars['Float']['input']>;
  type: GameMatchPositionType;
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  cup?: InputMaybe<Scalars['Int64']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exp?: InputMaybe<Scalars['Uint64']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * CreateWalletInput is used for create Wallet object.
 * Input was generated by ent.
 */
export type CreateWalletInput = {
  currency: WalletCurrency;
};

export type CreateWithdrawalInput = {
  address: Scalars['String']['input'];
  /** The user ID to create the wallet for */
  amount: Scalars['Uint64']['input'];
  currency: WalletCurrency;
};

export type FavoriteAsset = Node & {
  __typename?: 'FavoriteAsset';
  assetID: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** Ordering options for FavoriteAsset connections */
export type FavoriteAssetOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order FavoriteAssets. */
  field: FavoriteAssetOrderField;
};

/** Properties by which FavoriteAsset connections can be ordered. */
export enum FavoriteAssetOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * FavoriteAssetWhereInput is used for filtering FavoriteAsset objects.
 * Input was generated by ent.
 */
export type FavoriteAssetWhereInput = {
  and?: InputMaybe<Array<FavoriteAssetWhereInput>>;
  /** asset_id field predicates */
  assetID?: InputMaybe<Scalars['String']['input']>;
  assetIDContains?: InputMaybe<Scalars['String']['input']>;
  assetIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  assetIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  assetIDGT?: InputMaybe<Scalars['String']['input']>;
  assetIDGTE?: InputMaybe<Scalars['String']['input']>;
  assetIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  assetIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  assetIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  assetIDLT?: InputMaybe<Scalars['String']['input']>;
  assetIDLTE?: InputMaybe<Scalars['String']['input']>;
  assetIDNEQ?: InputMaybe<Scalars['String']['input']>;
  assetIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<FavoriteAssetWhereInput>;
  or?: InputMaybe<Array<FavoriteAssetWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Game = Node & {
  __typename?: 'Game';
  cover: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  cup: Scalars['Uint64']['output'];
  currency: GameCurrency;
  description?: Maybe<Scalars['String']['output']>;
  duration: Scalars['Duration']['output'];
  entryFee: Scalars['Uint64']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  loseExp: Scalars['Uint64']['output'];
  maxPlayers: Scalars['Uint8']['output'];
  maxPositions: Scalars['Uint8']['output'];
  minPlayers: Scalars['Uint8']['output'];
  rewardPrice: Scalars['Uint64']['output'];
  rewards?: Maybe<Array<Consumable>>;
  startVBalance: Scalars['Float']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  winExp: Scalars['Uint64']['output'];
};

/** A connection to a list of items. */
export type GameConnection = {
  __typename?: 'GameConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GameEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** GameCurrency is enum for the field currency */
export enum GameCurrency {
  Sol = 'SOL',
  Usdt = 'USDT',
}

/** An edge in a connection. */
export type GameEdge = {
  __typename?: 'GameEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Game>;
};

export type GameFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

export type GameMatch = Node & {
  __typename?: 'GameMatch';
  createdAt: Scalars['Time']['output'];
  endTime?: Maybe<Scalars['Time']['output']>;
  game: Game;
  gameID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  participants?: Maybe<Array<GameMatchParticipant>>;
  positions?: Maybe<Array<GameMatchPosition>>;
  startTime?: Maybe<Scalars['Time']['output']>;
  status: GameMatchStatus;
  updatedAt: Scalars['Time']['output'];
  winner?: Maybe<User>;
  winnerID?: Maybe<Scalars['ID']['output']>;
};

/** A connection to a list of items. */
export type GameMatchConnection = {
  __typename?: 'GameMatchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GameMatchEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GameMatchEdge = {
  __typename?: 'GameMatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameMatch>;
};

export type GameMatchFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for GameMatch connections */
export type GameMatchOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GameMatches. */
  field: GameMatchOrderField;
};

/** Properties by which GameMatch connections can be ordered. */
export enum GameMatchOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type GameMatchParticipant = Node & {
  __typename?: 'GameMatchParticipant';
  createdAt: Scalars['Time']['output'];
  currency: GameMatchParticipantCurrency;
  gameMatchID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  match: GameMatch;
  positions?: Maybe<Array<GameMatchPosition>>;
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
  vBalance: Scalars['Float']['output'];
};

/** A connection to a list of items. */
export type GameMatchParticipantConnection = {
  __typename?: 'GameMatchParticipantConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GameMatchParticipantEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** GameMatchParticipantCurrency is enum for the field currency */
export enum GameMatchParticipantCurrency {
  Sol = 'SOL',
  Usdt = 'USDT',
}

/** An edge in a connection. */
export type GameMatchParticipantEdge = {
  __typename?: 'GameMatchParticipantEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameMatchParticipant>;
};

/** Ordering options for GameMatchParticipant connections */
export type GameMatchParticipantOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GameMatchParticipants. */
  field: GameMatchParticipantOrderField;
};

/** Properties by which GameMatchParticipant connections can be ordered. */
export enum GameMatchParticipantOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * GameMatchParticipantWhereInput is used for filtering GameMatchParticipant objects.
 * Input was generated by ent.
 */
export type GameMatchParticipantWhereInput = {
  and?: InputMaybe<Array<GameMatchParticipantWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<GameMatchParticipantCurrency>;
  currencyIn?: InputMaybe<Array<GameMatchParticipantCurrency>>;
  currencyNEQ?: InputMaybe<GameMatchParticipantCurrency>;
  currencyNotIn?: InputMaybe<Array<GameMatchParticipantCurrency>>;
  /** game_match_id field predicates */
  gameMatchID?: InputMaybe<Scalars['ID']['input']>;
  gameMatchIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  gameMatchIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  gameMatchIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** match edge predicates */
  hasMatch?: InputMaybe<Scalars['Boolean']['input']>;
  hasMatchWith?: InputMaybe<Array<GameMatchWhereInput>>;
  /** positions edge predicates */
  hasPositions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPositionsWith?: InputMaybe<Array<GameMatchPositionWhereInput>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GameMatchParticipantWhereInput>;
  or?: InputMaybe<Array<GameMatchParticipantWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** v_balance field predicates */
  vBalance?: InputMaybe<Scalars['Float']['input']>;
  vBalanceGT?: InputMaybe<Scalars['Float']['input']>;
  vBalanceGTE?: InputMaybe<Scalars['Float']['input']>;
  vBalanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  vBalanceLT?: InputMaybe<Scalars['Float']['input']>;
  vBalanceLTE?: InputMaybe<Scalars['Float']['input']>;
  vBalanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  vBalanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GameMatchPosition = Node & {
  __typename?: 'GameMatchPosition';
  baseToken: Scalars['String']['output'];
  closePrice?: Maybe<Scalars['Float']['output']>;
  closedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  entryPrice: Scalars['Float']['output'];
  expiredAt?: Maybe<Scalars['Time']['output']>;
  gameMatchID: Scalars['ID']['output'];
  gameMatchParticipantID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  leverage: Scalars['Uint8']['output'];
  leverageID?: Maybe<Scalars['UUID']['output']>;
  liquidationPrice: Scalars['Float']['output'];
  margin: Scalars['Float']['output'];
  match: GameMatch;
  openedAt?: Maybe<Scalars['Time']['output']>;
  participant: GameMatchParticipant;
  profit?: Maybe<Scalars['Float']['output']>;
  quoteToken: Scalars['String']['output'];
  side: GameMatchPositionSide;
  size: Scalars['Float']['output'];
  status: GameMatchPositionStatus;
  stopLoss?: Maybe<Scalars['Float']['output']>;
  targetPoint?: Maybe<Scalars['Float']['output']>;
  type: GameMatchPositionType;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GameMatchPositionConnection = {
  __typename?: 'GameMatchPositionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GameMatchPositionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GameMatchPositionEdge = {
  __typename?: 'GameMatchPositionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GameMatchPosition>;
};

export type GameMatchPositionFilter = {
  gameMatchID?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for GameMatchPosition connections */
export type GameMatchPositionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GameMatchPositions. */
  field: GameMatchPositionOrderField;
};

/** Properties by which GameMatchPosition connections can be ordered. */
export enum GameMatchPositionOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** GameMatchPositionSide is enum for the field side */
export enum GameMatchPositionSide {
  Buy = 'buy',
  Sell = 'sell',
}

/** GameMatchPositionStatus is enum for the field status */
export enum GameMatchPositionStatus {
  Canceled = 'canceled',
  Closed = 'closed',
  Liquidated = 'liquidated',
  Open = 'open',
  Pending = 'pending',
}

/** GameMatchPositionType is enum for the field type */
export enum GameMatchPositionType {
  Limit = 'limit',
  Market = 'market',
}

/**
 * GameMatchPositionWhereInput is used for filtering GameMatchPosition objects.
 * Input was generated by ent.
 */
export type GameMatchPositionWhereInput = {
  and?: InputMaybe<Array<GameMatchPositionWhereInput>>;
  /** base_token field predicates */
  baseToken?: InputMaybe<Scalars['String']['input']>;
  baseTokenContains?: InputMaybe<Scalars['String']['input']>;
  baseTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  baseTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  baseTokenGT?: InputMaybe<Scalars['String']['input']>;
  baseTokenGTE?: InputMaybe<Scalars['String']['input']>;
  baseTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  baseTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  baseTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  baseTokenLT?: InputMaybe<Scalars['String']['input']>;
  baseTokenLTE?: InputMaybe<Scalars['String']['input']>;
  baseTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  baseTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** close_price field predicates */
  closePrice?: InputMaybe<Scalars['Float']['input']>;
  closePriceGT?: InputMaybe<Scalars['Float']['input']>;
  closePriceGTE?: InputMaybe<Scalars['Float']['input']>;
  closePriceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  closePriceIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  closePriceLT?: InputMaybe<Scalars['Float']['input']>;
  closePriceLTE?: InputMaybe<Scalars['Float']['input']>;
  closePriceNEQ?: InputMaybe<Scalars['Float']['input']>;
  closePriceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  closePriceNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** closed_at field predicates */
  closedAt?: InputMaybe<Scalars['Time']['input']>;
  closedAtGT?: InputMaybe<Scalars['Time']['input']>;
  closedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  closedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  closedAtLT?: InputMaybe<Scalars['Time']['input']>;
  closedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  closedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  closedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  closedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** entry_price field predicates */
  entryPrice?: InputMaybe<Scalars['Float']['input']>;
  entryPriceGT?: InputMaybe<Scalars['Float']['input']>;
  entryPriceGTE?: InputMaybe<Scalars['Float']['input']>;
  entryPriceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  entryPriceLT?: InputMaybe<Scalars['Float']['input']>;
  entryPriceLTE?: InputMaybe<Scalars['Float']['input']>;
  entryPriceNEQ?: InputMaybe<Scalars['Float']['input']>;
  entryPriceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** expired_at field predicates */
  expiredAt?: InputMaybe<Scalars['Time']['input']>;
  expiredAtGT?: InputMaybe<Scalars['Time']['input']>;
  expiredAtGTE?: InputMaybe<Scalars['Time']['input']>;
  expiredAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiredAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  expiredAtLT?: InputMaybe<Scalars['Time']['input']>;
  expiredAtLTE?: InputMaybe<Scalars['Time']['input']>;
  expiredAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  expiredAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  expiredAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** game_match_id field predicates */
  gameMatchID?: InputMaybe<Scalars['ID']['input']>;
  gameMatchIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  gameMatchIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  gameMatchIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** game_match_participant_id field predicates */
  gameMatchParticipantID?: InputMaybe<Scalars['ID']['input']>;
  gameMatchParticipantIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  gameMatchParticipantIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  gameMatchParticipantIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** match edge predicates */
  hasMatch?: InputMaybe<Scalars['Boolean']['input']>;
  hasMatchWith?: InputMaybe<Array<GameMatchWhereInput>>;
  /** participant edge predicates */
  hasParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  hasParticipantWith?: InputMaybe<Array<GameMatchParticipantWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** leverage field predicates */
  leverage?: InputMaybe<Scalars['Uint8']['input']>;
  leverageGT?: InputMaybe<Scalars['Uint8']['input']>;
  leverageGTE?: InputMaybe<Scalars['Uint8']['input']>;
  /** leverage_id field predicates */
  leverageID?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDGT?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDGTE?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  leverageIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  leverageIDLT?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDLTE?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDNEQ?: InputMaybe<Scalars['UUID']['input']>;
  leverageIDNotIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
  leverageIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  leverageIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  leverageLT?: InputMaybe<Scalars['Uint8']['input']>;
  leverageLTE?: InputMaybe<Scalars['Uint8']['input']>;
  leverageNEQ?: InputMaybe<Scalars['Uint8']['input']>;
  leverageNotIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  /** liquidation_price field predicates */
  liquidationPrice?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceGT?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceGTE?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  liquidationPriceLT?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceLTE?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceNEQ?: InputMaybe<Scalars['Float']['input']>;
  liquidationPriceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** margin field predicates */
  margin?: InputMaybe<Scalars['Float']['input']>;
  marginGT?: InputMaybe<Scalars['Float']['input']>;
  marginGTE?: InputMaybe<Scalars['Float']['input']>;
  marginIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  marginLT?: InputMaybe<Scalars['Float']['input']>;
  marginLTE?: InputMaybe<Scalars['Float']['input']>;
  marginNEQ?: InputMaybe<Scalars['Float']['input']>;
  marginNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  not?: InputMaybe<GameMatchPositionWhereInput>;
  /** opened_at field predicates */
  openedAt?: InputMaybe<Scalars['Time']['input']>;
  openedAtGT?: InputMaybe<Scalars['Time']['input']>;
  openedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  openedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  openedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  openedAtLT?: InputMaybe<Scalars['Time']['input']>;
  openedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  openedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  openedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  openedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<GameMatchPositionWhereInput>>;
  /** profit field predicates */
  profit?: InputMaybe<Scalars['Float']['input']>;
  profitGT?: InputMaybe<Scalars['Float']['input']>;
  profitGTE?: InputMaybe<Scalars['Float']['input']>;
  profitIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  profitIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  profitLT?: InputMaybe<Scalars['Float']['input']>;
  profitLTE?: InputMaybe<Scalars['Float']['input']>;
  profitNEQ?: InputMaybe<Scalars['Float']['input']>;
  profitNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  profitNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** quote_token field predicates */
  quoteToken?: InputMaybe<Scalars['String']['input']>;
  quoteTokenContains?: InputMaybe<Scalars['String']['input']>;
  quoteTokenContainsFold?: InputMaybe<Scalars['String']['input']>;
  quoteTokenEqualFold?: InputMaybe<Scalars['String']['input']>;
  quoteTokenGT?: InputMaybe<Scalars['String']['input']>;
  quoteTokenGTE?: InputMaybe<Scalars['String']['input']>;
  quoteTokenHasPrefix?: InputMaybe<Scalars['String']['input']>;
  quoteTokenHasSuffix?: InputMaybe<Scalars['String']['input']>;
  quoteTokenIn?: InputMaybe<Array<Scalars['String']['input']>>;
  quoteTokenLT?: InputMaybe<Scalars['String']['input']>;
  quoteTokenLTE?: InputMaybe<Scalars['String']['input']>;
  quoteTokenNEQ?: InputMaybe<Scalars['String']['input']>;
  quoteTokenNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** side field predicates */
  side?: InputMaybe<GameMatchPositionSide>;
  sideIn?: InputMaybe<Array<GameMatchPositionSide>>;
  sideNEQ?: InputMaybe<GameMatchPositionSide>;
  sideNotIn?: InputMaybe<Array<GameMatchPositionSide>>;
  /** size field predicates */
  size?: InputMaybe<Scalars['Float']['input']>;
  sizeGT?: InputMaybe<Scalars['Float']['input']>;
  sizeGTE?: InputMaybe<Scalars['Float']['input']>;
  sizeIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  sizeLT?: InputMaybe<Scalars['Float']['input']>;
  sizeLTE?: InputMaybe<Scalars['Float']['input']>;
  sizeNEQ?: InputMaybe<Scalars['Float']['input']>;
  sizeNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** status field predicates */
  status?: InputMaybe<GameMatchPositionStatus>;
  statusIn?: InputMaybe<Array<GameMatchPositionStatus>>;
  statusNEQ?: InputMaybe<GameMatchPositionStatus>;
  statusNotIn?: InputMaybe<Array<GameMatchPositionStatus>>;
  /** stop_loss field predicates */
  stopLoss?: InputMaybe<Scalars['Float']['input']>;
  stopLossGT?: InputMaybe<Scalars['Float']['input']>;
  stopLossGTE?: InputMaybe<Scalars['Float']['input']>;
  stopLossIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  stopLossIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  stopLossLT?: InputMaybe<Scalars['Float']['input']>;
  stopLossLTE?: InputMaybe<Scalars['Float']['input']>;
  stopLossNEQ?: InputMaybe<Scalars['Float']['input']>;
  stopLossNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  stopLossNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** target_point field predicates */
  targetPoint?: InputMaybe<Scalars['Float']['input']>;
  targetPointGT?: InputMaybe<Scalars['Float']['input']>;
  targetPointGTE?: InputMaybe<Scalars['Float']['input']>;
  targetPointIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  targetPointIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  targetPointLT?: InputMaybe<Scalars['Float']['input']>;
  targetPointLTE?: InputMaybe<Scalars['Float']['input']>;
  targetPointNEQ?: InputMaybe<Scalars['Float']['input']>;
  targetPointNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  targetPointNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** type field predicates */
  type?: InputMaybe<GameMatchPositionType>;
  typeIn?: InputMaybe<Array<GameMatchPositionType>>;
  typeNEQ?: InputMaybe<GameMatchPositionType>;
  typeNotIn?: InputMaybe<Array<GameMatchPositionType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type GameMatchPositionsPage = {
  __typename?: 'GameMatchPositionsPage';
  data?: Maybe<Array<GameMatchPosition>>;
  total: Scalars['Int']['output'];
};

/** GameMatchStatus is enum for the field status */
export enum GameMatchStatus {
  Closed = 'closed',
  Open = 'open',
  Pending = 'pending',
}

/**
 * GameMatchWhereInput is used for filtering GameMatch objects.
 * Input was generated by ent.
 */
export type GameMatchWhereInput = {
  and?: InputMaybe<Array<GameMatchWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** end_time field predicates */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeGT?: InputMaybe<Scalars['Time']['input']>;
  endTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  endTimeLT?: InputMaybe<Scalars['Time']['input']>;
  endTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  endTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** game_id field predicates */
  gameID?: InputMaybe<Scalars['ID']['input']>;
  gameIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  gameIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  gameIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** game edge predicates */
  hasGame?: InputMaybe<Scalars['Boolean']['input']>;
  hasGameWith?: InputMaybe<Array<GameWhereInput>>;
  /** participants edge predicates */
  hasParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  hasParticipantsWith?: InputMaybe<Array<GameMatchParticipantWhereInput>>;
  /** positions edge predicates */
  hasPositions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPositionsWith?: InputMaybe<Array<GameMatchPositionWhereInput>>;
  /** winner edge predicates */
  hasWinner?: InputMaybe<Scalars['Boolean']['input']>;
  hasWinnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GameMatchWhereInput>;
  or?: InputMaybe<Array<GameMatchWhereInput>>;
  /** start_time field predicates */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTimeGT?: InputMaybe<Scalars['Time']['input']>;
  startTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  startTimeLT?: InputMaybe<Scalars['Time']['input']>;
  startTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  startTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<GameMatchStatus>;
  statusIn?: InputMaybe<Array<GameMatchStatus>>;
  statusNEQ?: InputMaybe<GameMatchStatus>;
  statusNotIn?: InputMaybe<Array<GameMatchStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** winner_id field predicates */
  winnerID?: InputMaybe<Scalars['ID']['input']>;
  winnerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  winnerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  winnerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  winnerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  winnerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GameMatchesPage = {
  __typename?: 'GameMatchesPage';
  data?: Maybe<Array<GameMatch>>;
  total: Scalars['Int']['output'];
};

/** Ordering options for Game connections */
export type GameOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Games. */
  field: GameOrderField;
};

/** Properties by which Game connections can be ordered. */
export enum GameOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * GameWhereInput is used for filtering Game objects.
 * Input was generated by ent.
 */
export type GameWhereInput = {
  and?: InputMaybe<Array<GameWhereInput>>;
  /** cover field predicates */
  cover?: InputMaybe<Scalars['String']['input']>;
  coverContains?: InputMaybe<Scalars['String']['input']>;
  coverContainsFold?: InputMaybe<Scalars['String']['input']>;
  coverEqualFold?: InputMaybe<Scalars['String']['input']>;
  coverGT?: InputMaybe<Scalars['String']['input']>;
  coverGTE?: InputMaybe<Scalars['String']['input']>;
  coverHasPrefix?: InputMaybe<Scalars['String']['input']>;
  coverHasSuffix?: InputMaybe<Scalars['String']['input']>;
  coverIn?: InputMaybe<Array<Scalars['String']['input']>>;
  coverLT?: InputMaybe<Scalars['String']['input']>;
  coverLTE?: InputMaybe<Scalars['String']['input']>;
  coverNEQ?: InputMaybe<Scalars['String']['input']>;
  coverNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cup field predicates */
  cup?: InputMaybe<Scalars['Uint64']['input']>;
  cupGT?: InputMaybe<Scalars['Uint64']['input']>;
  cupGTE?: InputMaybe<Scalars['Uint64']['input']>;
  cupIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  cupLT?: InputMaybe<Scalars['Uint64']['input']>;
  cupLTE?: InputMaybe<Scalars['Uint64']['input']>;
  cupNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  cupNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<GameCurrency>;
  currencyIn?: InputMaybe<Array<GameCurrency>>;
  currencyNEQ?: InputMaybe<GameCurrency>;
  currencyNotIn?: InputMaybe<Array<GameCurrency>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** duration field predicates */
  duration?: InputMaybe<Scalars['Duration']['input']>;
  durationGT?: InputMaybe<Scalars['Duration']['input']>;
  durationGTE?: InputMaybe<Scalars['Duration']['input']>;
  durationIn?: InputMaybe<Array<Scalars['Duration']['input']>>;
  durationLT?: InputMaybe<Scalars['Duration']['input']>;
  durationLTE?: InputMaybe<Scalars['Duration']['input']>;
  durationNEQ?: InputMaybe<Scalars['Duration']['input']>;
  durationNotIn?: InputMaybe<Array<Scalars['Duration']['input']>>;
  /** entry_fee field predicates */
  entryFee?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeGT?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeGTE?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  entryFeeLT?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeLTE?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  entryFeeNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** rewards edge predicates */
  hasRewards?: InputMaybe<Scalars['Boolean']['input']>;
  hasRewardsWith?: InputMaybe<Array<ConsumableWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** lose_exp field predicates */
  loseExp?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpGT?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpGTE?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  loseExpLT?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpLTE?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  loseExpNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** max_players field predicates */
  maxPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersGT?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersGTE?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  maxPlayersLT?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersLTE?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersNEQ?: InputMaybe<Scalars['Uint8']['input']>;
  maxPlayersNotIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  /** max_positions field predicates */
  maxPositions?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsGT?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsGTE?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  maxPositionsLT?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsLTE?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsNEQ?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositionsNotIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  /** min_players field predicates */
  minPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersGT?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersGTE?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  minPlayersLT?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersLTE?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersNEQ?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayersNotIn?: InputMaybe<Array<Scalars['Uint8']['input']>>;
  not?: InputMaybe<GameWhereInput>;
  or?: InputMaybe<Array<GameWhereInput>>;
  /** reward_price field predicates */
  rewardPrice?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceGT?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceGTE?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  rewardPriceLT?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceLTE?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  rewardPriceNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** start_v_balance field predicates */
  startVBalance?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceGT?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceGTE?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  startVBalanceLT?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceLTE?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceNEQ?: InputMaybe<Scalars['Float']['input']>;
  startVBalanceNotIn?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** win_exp field predicates */
  winExp?: InputMaybe<Scalars['Uint64']['input']>;
  winExpGT?: InputMaybe<Scalars['Uint64']['input']>;
  winExpGTE?: InputMaybe<Scalars['Uint64']['input']>;
  winExpIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  winExpLT?: InputMaybe<Scalars['Uint64']['input']>;
  winExpLTE?: InputMaybe<Scalars['Uint64']['input']>;
  winExpNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  winExpNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
};

export type GamesPage = {
  __typename?: 'GamesPage';
  data?: Maybe<Array<Game>>;
  total: Scalars['Int']['output'];
};

export type Inventory = Node & {
  __typename?: 'Inventory';
  consumable: Consumable;
  consumableID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  positions?: Maybe<Array<GameMatchPosition>>;
  remainingUses: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type InventoryConnection = {
  __typename?: 'InventoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InventoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type InventoryEdge = {
  __typename?: 'InventoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Inventory>;
};

/** Ordering options for Inventory connections */
export type InventoryOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Inventories. */
  field: InventoryOrderField;
};

/** Properties by which Inventory connections can be ordered. */
export enum InventoryOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * InventoryWhereInput is used for filtering Inventory objects.
 * Input was generated by ent.
 */
export type InventoryWhereInput = {
  and?: InputMaybe<Array<InventoryWhereInput>>;
  /** consumable_id field predicates */
  consumableID?: InputMaybe<Scalars['ID']['input']>;
  consumableIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  consumableIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  consumableIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** consumable edge predicates */
  hasConsumable?: InputMaybe<Scalars['Boolean']['input']>;
  hasConsumableWith?: InputMaybe<Array<ConsumableWhereInput>>;
  /** positions edge predicates */
  hasPositions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPositionsWith?: InputMaybe<Array<GameMatchPositionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<InventoryWhereInput>;
  or?: InputMaybe<Array<InventoryWhereInput>>;
  /** remaining_uses field predicates */
  remainingUses?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesGT?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesGTE?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  remainingUsesLT?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesLTE?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  remainingUsesNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancel a game match position for a in progress match if eligible **(authenticated only)** */
  cancelGameMatchPosition: Scalars['Boolean']['output'];
  /** Close a game match position for a in progress match if eligible **(authenticated only)** */
  closeGameMatchPosition: GameMatchPosition;
  /** Create a new achievement **(permission: create:achievements)** */
  createAchievement: Achievement;
  /** Create a new achievements_rule **(permission: create:achievements_rule)** */
  createAchievementRule: AchievementRule;
  /** Create a new consumable **(permission: create:consumables)** */
  createConsumable: Consumable;
  /** Create a favorite asset **(authenticated only)** */
  createFavoriteAsset: Scalars['Boolean']['output'];
  /** Create a new game **(permission: create:games)** */
  createGame: Game;
  /** Create a new game match position for a in progress match **(authenticated only)** */
  createGameMatchPosition: GameMatchPosition;
  /** create a presigned URL for uploading an image file **(permission: create:resources)** */
  createResourceURL: Resource;
  /** Create a new user **(permission: create:users)** */
  createUser: User;
  /** Create a new wallet **(authenticated only)** */
  createWallet: Wallet;
  createWithdrawRequest: Transaction;
  /** Delete a achievement **(permission: delete:achievements)** */
  deleteAchievement: Scalars['Boolean']['output'];
  /** Delete a achievements_rule **(permission: delete:achievements_rule)** */
  deleteAchievementRule: Scalars['Boolean']['output'];
  /** Delete a consumable **(permission: delete:consumables)** */
  deleteConsumable: Scalars['Boolean']['output'];
  /** Delete a favorite asset **(authenticated only)** */
  deleteFavoriteAsset: Scalars['Boolean']['output'];
  /** Delete a game **(permission: delete:games)** */
  deleteGame: Scalars['Boolean']['output'];
  /** delete an uploaded resource by its key **(permission: delete:resources)** */
  deleteResource: Scalars['Boolean']['output'];
  /** Delete a user **(permission: delete:users)** */
  deleteUser: Scalars['Boolean']['output'];
  /** Join a game **(authenticated only)** */
  joinGame: Scalars['Boolean']['output'];
  loginWithEmail: Token;
  loginWithPassword: Token;
  noop: Scalars['String']['output'];
  refreshToken: Token;
  requestEmailVerificationCode: RequestVerificationCodePayload;
  /** Update a achievement **(permission: update:achievements)** */
  updateAchievement: Achievement;
  /** Update a consumable **(permission: update:consumables)** */
  updateConsumable: Consumable;
  /** Update a game **(permission: update:games)** */
  updateGame: Game;
  /** Update a game match position for a in progress match if eligible **(authenticated only)** */
  updateGameMatchPosition: GameMatchPosition;
  /** Update profile **(authenticated only)** */
  updateProfile: User;
  /** Update a user **(permission: update:users)** */
  updateUser: User;
};

export type MutationCancelGameMatchPositionArgs = {
  id: Scalars['ID']['input'];
};

export type MutationCloseGameMatchPositionArgs = {
  id: Scalars['ID']['input'];
  percentage: Scalars['Float']['input'];
};

export type MutationCreateAchievementArgs = {
  createAchievementInput: CreateAchievementInput;
};

export type MutationCreateAchievementRuleArgs = {
  createAchievementRuleInput: CreateAchievementRuleInput;
};

export type MutationCreateConsumableArgs = {
  createConsumableInput: CreateConsumableInput;
};

export type MutationCreateFavoriteAssetArgs = {
  assetID: Scalars['String']['input'];
};

export type MutationCreateGameArgs = {
  createGameInput: CreateGameInput;
};

export type MutationCreateGameMatchPositionArgs = {
  createGameInput: CreateGameMatchPositionInput;
};

export type MutationCreateResourceUrlArgs = {
  contentType: ResourceContentType;
  resourceType: ResourceType;
};

export type MutationCreateUserArgs = {
  createUserInput: CreateUserInput;
};

export type MutationCreateWalletArgs = {
  createWalletInput: CreateWalletInput;
};

export type MutationCreateWithdrawRequestArgs = {
  createWithdrawalInput: CreateWithdrawalInput;
};

export type MutationDeleteAchievementArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteAchievementRuleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteConsumableArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteFavoriteAssetArgs = {
  assetID: Scalars['String']['input'];
};

export type MutationDeleteGameArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteResourceArgs = {
  key: Scalars['String']['input'];
};

export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationJoinGameArgs = {
  id: Scalars['ID']['input'];
};

export type MutationLoginWithEmailArgs = {
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};

export type MutationLoginWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};

export type MutationRequestEmailVerificationCodeArgs = {
  email: Scalars['String']['input'];
};

export type MutationUpdateAchievementArgs = {
  id: Scalars['ID']['input'];
  updateAchievementInput: UpdateAchievementInput;
};

export type MutationUpdateConsumableArgs = {
  id: Scalars['ID']['input'];
  updateConsumableInput: UpdateConsumableInput;
};

export type MutationUpdateGameArgs = {
  id: Scalars['ID']['input'];
  updateGameInput: UpdateGameInput;
};

export type MutationUpdateGameMatchPositionArgs = {
  id: Scalars['ID']['input'];
  updateGameMatchPositionInput: UpdateGameMatchPositionInput;
};

export type MutationUpdateProfileArgs = {
  updateProfileInput: UpdateProfileInput;
};

export type MutationUpdateUserArgs = {
  id: Scalars['ID']['input'];
  updateUserInput: UpdateUserInput;
};

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  action?: Maybe<NotificationAction>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  event?: Maybe<NotificationEvent>;
  id?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  target?: Maybe<NotificationTarget>;
  type: NotificationType;
};

export enum NotificationAction {
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Created = 'CREATED',
  Updated = 'UPDATED',
}

export enum NotificationEvent {
  AchievementUnlocked = 'ACHIEVEMENT_UNLOCKED',
  AppNotification = 'APP_NOTIFICATION',
  MatchCanceled = 'MATCH_CANCELED',
  MatchClosed = 'MATCH_CLOSED',
  MatchCreated = 'MATCH_CREATED',
  PositionCanceled = 'POSITION_CANCELED',
  PositionClosed = 'POSITION_CLOSED',
  PositionLiquidated = 'POSITION_LIQUIDATED',
  PositionUpdated = 'POSITION_UPDATED',
  WalletBalanceUpdated = 'WALLET_BALANCE_UPDATED',
}

export enum NotificationTarget {
  Achievement = 'ACHIEVEMENT',
  App = 'App',
  Game = 'GAME',
  Match = 'MATCH',
  Position = 'POSITION',
  Wallet = 'WALLET',
}

export enum NotificationType {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC',
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  nickName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  /** Get a achievement by id **(permission: read:achievements)** */
  achievement: Achievement;
  /** Get a achievements_rule by id **(permission: read:achievements_rule)** */
  achievementRule: AchievementRule;
  /** Get all achievements_rule **(permission: read:achievements_rule)** */
  achievementRules: AchievementRuleConnection;
  /** Get all achievements_rule by page **(permission: read:achievements_rule)** */
  achievementRulesPage: AchievementRulesPage;
  /** Get all achievements **(authenticated only)** */
  achievements: AchievementConnection;
  /** Get all achievements by page **(permission: read:achievements)** */
  achievementsPage: AchievementsPage;
  asset?: Maybe<Asset>;
  assets?: Maybe<Array<Maybe<Asset>>>;
  /** Get a consumable by id **(permission: read:consumables)** */
  consumable: Consumable;
  /** Get all consumables **(permission: read:consumables)** */
  consumables: ConsumableConnection;
  /** Get all consumables by page **(permission: read:consumables)** */
  consumablesPage: ConsumablesPage;
  /** Get a game by id */
  game: Game;
  /** Get a game match by id **(permission: read:gameMatches)** */
  gameMatch: GameMatch;
  /** Get a game match position by id **(permission: read:gameMatchPositions)** */
  gameMatchPosition: GameMatchPosition;
  /** Get all game match positions **(permission: read:gameMatchPositions)** */
  gameMatchPositions: GameMatchPositionConnection;
  /** Get all game match positions by page **(permission: read:gameMatchPositions)** */
  gameMatchPositionsPage: GameMatchPositionsPage;
  /** Get all game match positions **(permission: read:gameMatches)** */
  gameMatches: GameMatchConnection;
  /** Get all game match positions by page **(permission: read:gameMatches)** */
  gameMatchesPage: GameMatchesPage;
  /** Get all games */
  games: GameConnection;
  /** Get all games by page */
  gamesPage: GamesPage;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Get the current user's profile **(authenticated only)** */
  profile: User;
  /** Get a transaction by id **(permission: read:transactions)** */
  transaction: Transaction;
  /** Get all transactions **(permission: read:transactions)** */
  transactions: TransactionConnection;
  /** Get all transactions by page **(permission: read:transactions)** */
  transactionsPage: TransactionsPage;
  /** Get a user by id **(permission: read:users)** */
  user: User;
  /** Get all users **(permission: read:users)** */
  users: UserConnection;
  /** Get all users by page **(permission: read:users)** */
  usersPage: UsersPage;
  /** Get a wallet by id **(permission: read:wallets)** */
  wallet: Wallet;
  /** Get all wallets **(permission: read:wallets)** */
  wallets: WalletConnection;
  /** Get all wallets by page **(permission: read:wallets)** */
  walletsPage: WalletsPage;
};

export type QueryAchievementArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAchievementRuleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryAchievementRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AchievementRuleFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AchievementRuleOrder>;
};

export type QueryAchievementRulesPageArgs = {
  filterBy?: InputMaybe<AchievementRuleFilter>;
  orderBy?: InputMaybe<AchievementRuleOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryAchievementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<AchievementFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AchievementOrder>;
};

export type QueryAchievementsPageArgs = {
  filterBy?: InputMaybe<AchievementFilter>;
  orderBy?: InputMaybe<AchievementOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryAssetArgs = {
  id: Scalars['String']['input'];
};

export type QueryConsumableArgs = {
  id: Scalars['ID']['input'];
};

export type QueryConsumablesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<ConsumableFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ConsumableOrder>;
};

export type QueryConsumablesPageArgs = {
  filterBy?: InputMaybe<ConsumableFilter>;
  orderBy?: InputMaybe<ConsumableOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryGameArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGameMatchArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGameMatchPositionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGameMatchPositionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<GameMatchPositionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameMatchPositionOrder>;
};

export type QueryGameMatchPositionsPageArgs = {
  filterBy?: InputMaybe<GameMatchPositionFilter>;
  orderBy?: InputMaybe<GameMatchPositionOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryGameMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<GameMatchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameMatchOrder>;
};

export type QueryGameMatchesPageArgs = {
  filterBy?: InputMaybe<GameMatchFilter>;
  orderBy?: InputMaybe<GameMatchOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryGamesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<GameFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameOrder>;
};

export type QueryGamesPageArgs = {
  filterBy?: InputMaybe<GameFilter>;
  orderBy?: InputMaybe<GameOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};

export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};

export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<TransactionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TransactionOrder>;
};

export type QueryTransactionsPageArgs = {
  filterBy?: InputMaybe<TransactionFilter>;
  orderBy?: InputMaybe<TransactionOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserOrder>;
};

export type QueryUsersPageArgs = {
  filterBy?: InputMaybe<UserFilter>;
  orderBy?: InputMaybe<UserOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type QueryWalletArgs = {
  id: Scalars['ID']['input'];
};

export type QueryWalletsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filterBy?: InputMaybe<WalletFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WalletOrder>;
};

export type QueryWalletsPageArgs = {
  filterBy?: InputMaybe<WalletFilter>;
  orderBy?: InputMaybe<WalletOrder>;
  paginateBy?: InputMaybe<Pagination>;
};

export type RequestVerificationCodePayload = {
  __typename?: 'RequestVerificationCodePayload';
  expiresIn: Scalars['Int']['output'];
};

export type Resource = {
  __typename?: 'Resource';
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum ResourceContentType {
  ImageJpeg = 'IMAGE_JPEG',
  ImagePng = 'IMAGE_PNG',
}

export enum ResourceType {
  Achievement = 'Achievement',
  Asset = 'Asset',
  Consumable = 'Consumable',
  Game = 'Game',
  Package = 'Package',
}

export type Subscription = {
  __typename?: 'Subscription';
  /**  Subscribe to global notification **(authenticated only)** */
  NotificationGlobal: Notification;
  /**  Subscribe to match notification **(authenticated only)** */
  NotificationMatch: Notification;
  /** Subscribe to asset (single) updates */
  assetUpdated?: Maybe<AssetUpdate>;
  /** Subscribe to assets (multiple) updates */
  assetsUpdated?: Maybe<Array<Maybe<AssetUpdate>>>;
  /** Subscribe to time updates */
  currentTime: Scalars['String']['output'];
};

export type SubscriptionNotificationMatchArgs = {
  matchId: Scalars['ID']['input'];
};

export type SubscriptionAssetUpdatedArgs = {
  id: Scalars['String']['input'];
};

export type Token = {
  __typename?: 'Token';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export type Transaction = Node & {
  __typename?: 'Transaction';
  amount: Scalars['Int']['output'];
  balanceAfterTransaction: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ref?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  type: TransactionType;
  updatedAt: Scalars['Time']['output'];
  walletID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TransactionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Transaction>;
};

export type TransactionFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  walletID?: InputMaybe<Scalars['ID']['input']>;
};

/** Ordering options for Transaction connections */
export type TransactionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Transactions. */
  field: TransactionOrderField;
};

/** Properties by which Transaction connections can be ordered. */
export enum TransactionOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** TransactionStatus is enum for the field status */
export enum TransactionStatus {
  Canceled = 'canceled',
  Completed = 'completed',
  Failed = 'failed',
  Pending = 'pending',
}

/** TransactionType is enum for the field type */
export enum TransactionType {
  Deposit = 'deposit',
  Withdraw = 'withdraw',
}

/**
 * TransactionWhereInput is used for filtering Transaction objects.
 * Input was generated by ent.
 */
export type TransactionWhereInput = {
  /** amount field predicates */
  amount?: InputMaybe<Scalars['Int']['input']>;
  amountGT?: InputMaybe<Scalars['Int']['input']>;
  amountGTE?: InputMaybe<Scalars['Int']['input']>;
  amountIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  amountLT?: InputMaybe<Scalars['Int']['input']>;
  amountLTE?: InputMaybe<Scalars['Int']['input']>;
  amountNEQ?: InputMaybe<Scalars['Int']['input']>;
  amountNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  and?: InputMaybe<Array<TransactionWhereInput>>;
  /** balance_after_transaction field predicates */
  balanceAfterTransaction?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionGT?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionGTE?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  balanceAfterTransactionLT?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionLTE?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionNEQ?: InputMaybe<Scalars['Int']['input']>;
  balanceAfterTransactionNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** description field predicates */
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionContains?: InputMaybe<Scalars['String']['input']>;
  descriptionContainsFold?: InputMaybe<Scalars['String']['input']>;
  descriptionEqualFold?: InputMaybe<Scalars['String']['input']>;
  descriptionGT?: InputMaybe<Scalars['String']['input']>;
  descriptionGTE?: InputMaybe<Scalars['String']['input']>;
  descriptionHasPrefix?: InputMaybe<Scalars['String']['input']>;
  descriptionHasSuffix?: InputMaybe<Scalars['String']['input']>;
  descriptionIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  descriptionLT?: InputMaybe<Scalars['String']['input']>;
  descriptionLTE?: InputMaybe<Scalars['String']['input']>;
  descriptionNEQ?: InputMaybe<Scalars['String']['input']>;
  descriptionNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  descriptionNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<TransactionWhereInput>;
  or?: InputMaybe<Array<TransactionWhereInput>>;
  /** ref field predicates */
  ref?: InputMaybe<Scalars['String']['input']>;
  refContains?: InputMaybe<Scalars['String']['input']>;
  refContainsFold?: InputMaybe<Scalars['String']['input']>;
  refEqualFold?: InputMaybe<Scalars['String']['input']>;
  refGT?: InputMaybe<Scalars['String']['input']>;
  refGTE?: InputMaybe<Scalars['String']['input']>;
  refHasPrefix?: InputMaybe<Scalars['String']['input']>;
  refHasSuffix?: InputMaybe<Scalars['String']['input']>;
  refIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  refLT?: InputMaybe<Scalars['String']['input']>;
  refLTE?: InputMaybe<Scalars['String']['input']>;
  refNEQ?: InputMaybe<Scalars['String']['input']>;
  refNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  refNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<TransactionStatus>;
  statusIn?: InputMaybe<Array<TransactionStatus>>;
  statusNEQ?: InputMaybe<TransactionStatus>;
  statusNotIn?: InputMaybe<Array<TransactionStatus>>;
  /** type field predicates */
  type?: InputMaybe<TransactionType>;
  typeIn?: InputMaybe<Array<TransactionType>>;
  typeNEQ?: InputMaybe<TransactionType>;
  typeNotIn?: InputMaybe<Array<TransactionType>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** wallet_id field predicates */
  walletID?: InputMaybe<Scalars['ID']['input']>;
  walletIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  walletIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  walletIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TransactionsPage = {
  __typename?: 'TransactionsPage';
  data?: Maybe<Array<Transaction>>;
  total: Scalars['Int']['output'];
};

/**
 * UpdateAchievementInput is used for update Achievement object.
 * Input was generated by ent.
 */
export type UpdateAchievementInput = {
  addRewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  addRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearExpiresAt?: InputMaybe<Scalars['Boolean']['input']>;
  clearRewards?: InputMaybe<Scalars['Boolean']['input']>;
  clearRules?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeRewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removeRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * UpdateConsumableInput is used for update Consumable object.
 * Input was generated by ent.
 */
export type UpdateConsumableInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ConsumableType>;
  value?: InputMaybe<Scalars['Uint64']['input']>;
};

/**
 * UpdateGameInput is used for update Game object.
 * Input was generated by ent.
 */
export type UpdateGameInput = {
  addRewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  clearDescription?: InputMaybe<Scalars['Boolean']['input']>;
  clearRewards?: InputMaybe<Scalars['Boolean']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  cup?: InputMaybe<Scalars['Uint64']['input']>;
  currency?: InputMaybe<GameCurrency>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Duration']['input']>;
  entryFee?: InputMaybe<Scalars['Uint64']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  loseExp?: InputMaybe<Scalars['Uint64']['input']>;
  maxPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  maxPositions?: InputMaybe<Scalars['Uint8']['input']>;
  minPlayers?: InputMaybe<Scalars['Uint8']['input']>;
  removeRewardIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  rewardPrice?: InputMaybe<Scalars['Uint64']['input']>;
  startVBalance?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  winExp?: InputMaybe<Scalars['Uint64']['input']>;
};

/**
 * UpdateGameMatchPositionInput is used for update GameMatchPosition object.
 * Input was generated by ent.
 */
export type UpdateGameMatchPositionInput = {
  clearLeverageID?: InputMaybe<Scalars['Boolean']['input']>;
  clearStopLoss?: InputMaybe<Scalars['Boolean']['input']>;
  clearTargetPoint?: InputMaybe<Scalars['Boolean']['input']>;
  leverageID?: InputMaybe<Scalars['UUID']['input']>;
  stopLoss?: InputMaybe<Scalars['Float']['input']>;
  targetPoint?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateProfileInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  nickName: Scalars['String']['input'];
};

/**
 * UpdateUserInput is used for update User object.
 * Input was generated by ent.
 */
export type UpdateUserInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  clearAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  clearEmail?: InputMaybe<Scalars['Boolean']['input']>;
  clearNickName?: InputMaybe<Scalars['Boolean']['input']>;
  cup?: InputMaybe<Scalars['Int64']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exp?: InputMaybe<Scalars['Uint64']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  achievements: UserAchievementConnection;
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  cup: Scalars['Int64']['output'];
  email?: Maybe<Scalars['String']['output']>;
  exp: Scalars['Uint64']['output'];
  favoriteAssets?: Maybe<Array<FavoriteAsset>>;
  id: Scalars['ID']['output'];
  inventories: InventoryConnection;
  isActive: Scalars['Boolean']['output'];
  isEmailVerified: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  isSuperuser: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  matches: GameMatchParticipantConnection;
  nickName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
  wallets?: Maybe<Array<Wallet>>;
  wonMatches: GameMatchConnection;
};

export type UserAchievementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserAchievementOrder>;
  where?: InputMaybe<UserAchievementWhereInput>;
};

export type UserInventoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<InventoryOrder>;
  where?: InputMaybe<InventoryWhereInput>;
};

export type UserMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameMatchParticipantOrder>;
  where?: InputMaybe<GameMatchParticipantWhereInput>;
};

export type UserWonMatchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameMatchOrder>;
  where?: InputMaybe<GameMatchWhereInput>;
};

export type UserAchievement = Node & {
  __typename?: 'UserAchievement';
  achievementID: Scalars['ID']['output'];
  completedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  isCompleted: Scalars['Boolean']['output'];
  progress: Scalars['Int']['output'];
  updatedAt: Scalars['Time']['output'];
  user: User;
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type UserAchievementConnection = {
  __typename?: 'UserAchievementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserAchievementEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserAchievementEdge = {
  __typename?: 'UserAchievementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserAchievement>;
};

/** Ordering options for UserAchievement connections */
export type UserAchievementOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserAchievements. */
  field: UserAchievementOrderField;
};

/** Properties by which UserAchievement connections can be ordered. */
export enum UserAchievementOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * UserAchievementWhereInput is used for filtering UserAchievement objects.
 * Input was generated by ent.
 */
export type UserAchievementWhereInput = {
  /** achievement_id field predicates */
  achievementID?: InputMaybe<Scalars['ID']['input']>;
  achievementIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  achievementIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  achievementIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  and?: InputMaybe<Array<UserAchievementWhereInput>>;
  /** completed_at field predicates */
  completedAt?: InputMaybe<Scalars['Time']['input']>;
  completedAtGT?: InputMaybe<Scalars['Time']['input']>;
  completedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  completedAtLT?: InputMaybe<Scalars['Time']['input']>;
  completedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  completedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  completedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  completedAtNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user edge predicates */
  hasUser?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_completed field predicates */
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompletedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserAchievementWhereInput>;
  or?: InputMaybe<Array<UserAchievementWhereInput>>;
  /** progress field predicates */
  progress?: InputMaybe<Scalars['Int']['input']>;
  progressGT?: InputMaybe<Scalars['Int']['input']>;
  progressGTE?: InputMaybe<Scalars['Int']['input']>;
  progressIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  progressLT?: InputMaybe<Scalars['Int']['input']>;
  progressLTE?: InputMaybe<Scalars['Int']['input']>;
  progressNEQ?: InputMaybe<Scalars['Int']['input']>;
  progressNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

/** Ordering options for User connections */
export type UserOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Users. */
  field: UserOrderField;
};

/** Properties by which User connections can be ordered. */
export enum UserOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  and?: InputMaybe<Array<UserWhereInput>>;
  /** avatar field predicates */
  avatar?: InputMaybe<Scalars['String']['input']>;
  avatarContains?: InputMaybe<Scalars['String']['input']>;
  avatarContainsFold?: InputMaybe<Scalars['String']['input']>;
  avatarEqualFold?: InputMaybe<Scalars['String']['input']>;
  avatarGT?: InputMaybe<Scalars['String']['input']>;
  avatarGTE?: InputMaybe<Scalars['String']['input']>;
  avatarHasPrefix?: InputMaybe<Scalars['String']['input']>;
  avatarHasSuffix?: InputMaybe<Scalars['String']['input']>;
  avatarIn?: InputMaybe<Array<Scalars['String']['input']>>;
  avatarIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  avatarLT?: InputMaybe<Scalars['String']['input']>;
  avatarLTE?: InputMaybe<Scalars['String']['input']>;
  avatarNEQ?: InputMaybe<Scalars['String']['input']>;
  avatarNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  avatarNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** cup field predicates */
  cup?: InputMaybe<Scalars['Int64']['input']>;
  cupGT?: InputMaybe<Scalars['Int64']['input']>;
  cupGTE?: InputMaybe<Scalars['Int64']['input']>;
  cupIn?: InputMaybe<Array<Scalars['Int64']['input']>>;
  cupLT?: InputMaybe<Scalars['Int64']['input']>;
  cupLTE?: InputMaybe<Scalars['Int64']['input']>;
  cupNEQ?: InputMaybe<Scalars['Int64']['input']>;
  cupNotIn?: InputMaybe<Array<Scalars['Int64']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** exp field predicates */
  exp?: InputMaybe<Scalars['Uint64']['input']>;
  expGT?: InputMaybe<Scalars['Uint64']['input']>;
  expGTE?: InputMaybe<Scalars['Uint64']['input']>;
  expIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  expLT?: InputMaybe<Scalars['Uint64']['input']>;
  expLTE?: InputMaybe<Scalars['Uint64']['input']>;
  expNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  expNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** achievements edge predicates */
  hasAchievements?: InputMaybe<Scalars['Boolean']['input']>;
  hasAchievementsWith?: InputMaybe<Array<UserAchievementWhereInput>>;
  /** favorite_assets edge predicates */
  hasFavoriteAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasFavoriteAssetsWith?: InputMaybe<Array<FavoriteAssetWhereInput>>;
  /** inventories edge predicates */
  hasInventories?: InputMaybe<Scalars['Boolean']['input']>;
  hasInventoriesWith?: InputMaybe<Array<InventoryWhereInput>>;
  /** matches edge predicates */
  hasMatches?: InputMaybe<Scalars['Boolean']['input']>;
  hasMatchesWith?: InputMaybe<Array<GameMatchParticipantWhereInput>>;
  /** wallets edge predicates */
  hasWallets?: InputMaybe<Scalars['Boolean']['input']>;
  hasWalletsWith?: InputMaybe<Array<WalletWhereInput>>;
  /** won_matches edge predicates */
  hasWonMatches?: InputMaybe<Scalars['Boolean']['input']>;
  hasWonMatchesWith?: InputMaybe<Array<GameMatchWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** is_active field predicates */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isActiveNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_email_verified field predicates */
  isEmailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailVerifiedNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_staff field predicates */
  isStaff?: InputMaybe<Scalars['Boolean']['input']>;
  isStaffNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** is_superuser field predicates */
  isSuperuser?: InputMaybe<Scalars['Boolean']['input']>;
  isSuperuserNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  /** level field predicates */
  level?: InputMaybe<Scalars['Int']['input']>;
  levelGT?: InputMaybe<Scalars['Int']['input']>;
  levelGTE?: InputMaybe<Scalars['Int']['input']>;
  levelIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  levelLT?: InputMaybe<Scalars['Int']['input']>;
  levelLTE?: InputMaybe<Scalars['Int']['input']>;
  levelNEQ?: InputMaybe<Scalars['Int']['input']>;
  levelNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** nick_name field predicates */
  nickName?: InputMaybe<Scalars['String']['input']>;
  nickNameContains?: InputMaybe<Scalars['String']['input']>;
  nickNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nickNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nickNameGT?: InputMaybe<Scalars['String']['input']>;
  nickNameGTE?: InputMaybe<Scalars['String']['input']>;
  nickNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nickNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nickNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nickNameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  nickNameLT?: InputMaybe<Scalars['String']['input']>;
  nickNameLTE?: InputMaybe<Scalars['String']['input']>;
  nickNameNEQ?: InputMaybe<Scalars['String']['input']>;
  nickNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nickNameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type UsersPage = {
  __typename?: 'UsersPage';
  data?: Maybe<Array<User>>;
  total: Scalars['Int']['output'];
};

export type Wallet = Node & {
  __typename?: 'Wallet';
  /** Get wallet public key address */
  address?: Maybe<Scalars['String']['output']>;
  balance: Scalars['Uint64']['output'];
  createdAt: Scalars['Time']['output'];
  currency: WalletCurrency;
  id: Scalars['ID']['output'];
  locked: Scalars['Uint64']['output'];
  updatedAt: Scalars['Time']['output'];
  userID: Scalars['ID']['output'];
};

/** A connection to a list of items. */
export type WalletConnection = {
  __typename?: 'WalletConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WalletEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** WalletCurrency is enum for the field currency */
export enum WalletCurrency {
  Sol = 'SOL',
  Usdt = 'USDT',
}

/** An edge in a connection. */
export type WalletEdge = {
  __typename?: 'WalletEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Wallet>;
};

export type WalletFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  userID?: InputMaybe<Scalars['ID']['input']>;
};

/** Ordering options for Wallet connections */
export type WalletOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order Wallets. */
  field: WalletOrderField;
};

/** Properties by which Wallet connections can be ordered. */
export enum WalletOrderField {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * WalletWhereInput is used for filtering Wallet objects.
 * Input was generated by ent.
 */
export type WalletWhereInput = {
  and?: InputMaybe<Array<WalletWhereInput>>;
  /** balance field predicates */
  balance?: InputMaybe<Scalars['Uint64']['input']>;
  balanceGT?: InputMaybe<Scalars['Uint64']['input']>;
  balanceGTE?: InputMaybe<Scalars['Uint64']['input']>;
  balanceIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  balanceLT?: InputMaybe<Scalars['Uint64']['input']>;
  balanceLTE?: InputMaybe<Scalars['Uint64']['input']>;
  balanceNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  balanceNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** currency field predicates */
  currency?: InputMaybe<WalletCurrency>;
  currencyIn?: InputMaybe<Array<WalletCurrency>>;
  currencyNEQ?: InputMaybe<WalletCurrency>;
  currencyNotIn?: InputMaybe<Array<WalletCurrency>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** locked field predicates */
  locked?: InputMaybe<Scalars['Uint64']['input']>;
  lockedGT?: InputMaybe<Scalars['Uint64']['input']>;
  lockedGTE?: InputMaybe<Scalars['Uint64']['input']>;
  lockedIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  lockedLT?: InputMaybe<Scalars['Uint64']['input']>;
  lockedLTE?: InputMaybe<Scalars['Uint64']['input']>;
  lockedNEQ?: InputMaybe<Scalars['Uint64']['input']>;
  lockedNotIn?: InputMaybe<Array<Scalars['Uint64']['input']>>;
  not?: InputMaybe<WalletWhereInput>;
  or?: InputMaybe<Array<WalletWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_id field predicates */
  userID?: InputMaybe<Scalars['ID']['input']>;
  userIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type WalletsPage = {
  __typename?: 'WalletsPage';
  data?: Maybe<Array<Wallet>>;
  total: Scalars['Int']['output'];
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type LoginWithEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
}>;

export type LoginWithEmailMutation = {
  __typename?: 'Mutation';
  loginWithEmail: {
    __typename?: 'Token';
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
};

export type LoginWithPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginWithPasswordMutation = {
  __typename?: 'Mutation';
  loginWithPassword: {
    __typename?: 'Token';
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
};

export type RequestEmailVerificationCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RequestEmailVerificationCodeMutation = {
  __typename?: 'Mutation';
  requestEmailVerificationCode: {
    __typename?: 'RequestVerificationCodePayload';
    expiresIn: number;
  };
};

export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;

export type RefreshTokenMutation = {
  __typename?: 'Mutation';
  refreshToken: {
    __typename?: 'Token';
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
  };
};

export type CreateGameMatchPositionMutationVariables = Exact<{
  createGameInput: CreateGameMatchPositionInput;
}>;

export type CreateGameMatchPositionMutation = {
  __typename?: 'Mutation';
  createGameMatchPosition: {
    __typename?: 'GameMatchPosition';
    id: string;
    createdAt: any;
    gameMatchID: string;
    quoteToken: string;
    entryPrice: number;
    liquidationPrice: number;
    size: number;
    profit?: number | null;
    expiredAt?: any | null;
    openedAt?: any | null;
    closedAt?: any | null;
    targetPoint?: number | null;
    stopLoss?: number | null;
    participant: {
      __typename?: 'GameMatchParticipant';
      currency: GameMatchParticipantCurrency;
      vBalance: number;
      match: {__typename?: 'GameMatch'; id: string};
      user: {
        __typename?: 'User';
        nickName?: string | null;
        avatar?: string | null;
      };
    };
    match: {
      __typename?: 'GameMatch';
      id: string;
      status: GameMatchStatus;
      startTime?: any | null;
      endTime?: any | null;
    };
  };
};

export type CancelGameMatchPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type CancelGameMatchPositionMutation = {
  __typename?: 'Mutation';
  cancelGameMatchPosition: boolean;
};

export type CloseGameMatchPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  percentage: Scalars['Float']['input'];
}>;

export type CloseGameMatchPositionMutation = {
  __typename?: 'Mutation';
  closeGameMatchPosition: {__typename?: 'GameMatchPosition'; id: string};
};

export type JoinToGameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type JoinToGameMutation = {__typename?: 'Mutation'; joinGame: boolean};

export type UpdateProfileMutationVariables = Exact<{
  updateProfileInput: UpdateProfileInput;
}>;

export type UpdateProfileMutation = {
  __typename?: 'Mutation';
  updateProfile: {__typename?: 'User'; id: string};
};

export type CreateWalletMutationVariables = Exact<{
  createWalletInput: CreateWalletInput;
}>;

export type CreateWalletMutation = {
  __typename?: 'Mutation';
  createWallet: {
    __typename?: 'Wallet';
    id: string;
    createdAt: any;
    updatedAt: any;
    currency: WalletCurrency;
    userID: string;
    balance: any;
    locked: any;
    address?: string | null;
  };
};

export type CreateWithdrawRequestMutationVariables = Exact<{
  createWithdrawalInput: CreateWithdrawalInput;
}>;

export type CreateWithdrawRequestMutation = {
  __typename?: 'Mutation';
  createWithdrawRequest: {
    __typename?: 'Transaction';
    id: string;
    updatedAt: any;
    createdAt: any;
    amount: number;
    balanceAfterTransaction: number;
    type: TransactionType;
    description?: string | null;
    ref?: string | null;
    status: TransactionStatus;
    walletID: string;
  };
};

export type GetAchievementsQueryVariables = Exact<{[key: string]: never}>;

export type GetAchievementsQuery = {
  __typename?: 'Query';
  achievements: {
    __typename?: 'AchievementConnection';
    edges?: Array<{
      __typename?: 'AchievementEdge';
      node?: {
        __typename?: 'Achievement';
        id: string;
        name: string;
        description?: string | null;
        avatar: string;
        createdAt: any;
        updatedAt: any;
        expiresAt?: any | null;
        isHidden: boolean;
        isActive: boolean;
        key: string;
        rewards?: Array<{
          __typename?: 'Consumable';
          id: string;
          createdAt: any;
          updatedAt: any;
          name: string;
          description?: string | null;
          avatar: string;
          value: any;
          type: ConsumableType;
        }> | null;
        rules?: Array<{
          __typename?: 'AchievementRule';
          id: string;
          createdAt: any;
          updatedAt: any;
          field: AchievementRuleField;
          comparator: AchievementRuleComparator;
          weight: number;
          target: number;
        }> | null;
      } | null;
    } | null> | null;
  };
};

export type GetAssetsQueryVariables = Exact<{[key: string]: never}>;

export type GetAssetsQuery = {
  __typename?: 'Query';
  assets?: Array<{
    __typename?: 'Asset';
    id: string;
    name: string;
    priceUSD: number;
    iconUrl: string;
    volumeUSD24Hr: number;
  } | null> | null;
};

export type AssetsSubscriptionVariables = Exact<{[key: string]: never}>;

export type AssetsSubscription = {
  __typename?: 'Subscription';
  assetsUpdated?: Array<{
    __typename?: 'AssetUpdate';
    id: string;
    priceUSD: number;
  } | null> | null;
};

export type GetActiveGamesLimitedQueryVariables = Exact<{[key: string]: never}>;

export type GetActiveGamesLimitedQuery = {
  __typename?: 'Query';
  games: {
    __typename?: 'GameConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'GameEdge';
      node?: {
        __typename?: 'Game';
        id: string;
        createdAt: any;
        currency: GameCurrency;
        title: string;
        description?: string | null;
        isActive: boolean;
        duration: any;
        maxPlayers: any;
        cover: string;
        startVBalance: number;
        minPlayers: any;
        entryFee: any;
        winExp: any;
        loseExp: any;
        cup: any;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      endCursor?: any | null;
    };
  };
};

export type GetDetailsGameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetDetailsGameQuery = {
  __typename?: 'Query';
  game: {
    __typename?: 'Game';
    id: string;
    createdAt: any;
    currency: GameCurrency;
    title: string;
    description?: string | null;
    isActive: boolean;
    duration: any;
    maxPlayers: any;
    cover: string;
    startVBalance: number;
    minPlayers: any;
    entryFee: any;
    winExp: any;
    loseExp: any;
    cup: any;
  };
};

export type GetMatchsQueryVariables = Exact<{[key: string]: never}>;

export type GetMatchsQuery = {
  __typename?: 'Query';
  profile: {
    __typename?: 'User';
    matches: {
      __typename?: 'GameMatchParticipantConnection';
      edges?: Array<{
        __typename?: 'GameMatchParticipantEdge';
        node?: {
          __typename?: 'GameMatchParticipant';
          positions?: Array<{
            __typename?: 'GameMatchPosition';
            gameMatchID: string;
            status: GameMatchPositionStatus;
            id: string;
            createdAt: any;
            updatedAt: any;
            gameMatchParticipantID: string;
            baseToken: string;
            quoteToken: string;
            entryPrice: number;
            size: number;
            profit?: number | null;
            side: GameMatchPositionSide;
            expiredAt?: any | null;
            targetPoint?: number | null;
            closedAt?: any | null;
            openedAt?: any | null;
            stopLoss?: number | null;
            participant: {
              __typename?: 'GameMatchParticipant';
              currency: GameMatchParticipantCurrency;
            };
          }> | null;
          match: {
            __typename?: 'GameMatch';
            id: string;
            status: GameMatchStatus;
            startTime?: any | null;
            endTime?: any | null;
            winner?: {__typename?: 'User'; nickName?: string | null} | null;
            game: {
              __typename?: 'Game';
              startVBalance: number;
              title: string;
              duration: any;
            };
            participants?: Array<{
              __typename?: 'GameMatchParticipant';
              vBalance: number;
              currency: GameMatchParticipantCurrency;
              positions?: Array<{
                __typename?: 'GameMatchPosition';
                id: string;
                createdAt: any;
                gameMatchID: string;
                quoteToken: string;
                entryPrice: number;
                side: GameMatchPositionSide;
                liquidationPrice: number;
                size: number;
                profit?: number | null;
                expiredAt?: any | null;
                openedAt?: any | null;
                closedAt?: any | null;
                targetPoint?: number | null;
                stopLoss?: number | null;
                participant: {
                  __typename?: 'GameMatchParticipant';
                  currency: GameMatchParticipantCurrency;
                  vBalance: number;
                  match: {__typename?: 'GameMatch'; id: string};
                  user: {
                    __typename?: 'User';
                    nickName?: string | null;
                    avatar?: string | null;
                  };
                };
                match: {
                  __typename?: 'GameMatch';
                  id: string;
                  status: GameMatchStatus;
                  startTime?: any | null;
                  endTime?: any | null;
                };
              }> | null;
              user: {
                __typename?: 'User';
                nickName?: string | null;
                avatar?: string | null;
                id: string;
                wallets?: Array<{
                  __typename?: 'Wallet';
                  balance: any;
                  currency: WalletCurrency;
                }> | null;
              };
            }> | null;
          };
        } | null;
      } | null> | null;
    };
  };
};

export type GetOneMatchQueryVariables = Exact<{
  where: GameMatchParticipantWhereInput;
}>;

export type GetOneMatchQuery = {
  __typename?: 'Query';
  profile: {
    __typename?: 'User';
    matches: {
      __typename?: 'GameMatchParticipantConnection';
      edges?: Array<{
        __typename?: 'GameMatchParticipantEdge';
        node?: {
          __typename?: 'GameMatchParticipant';
          positions?: Array<{
            __typename?: 'GameMatchPosition';
            gameMatchID: string;
            status: GameMatchPositionStatus;
            id: string;
            createdAt: any;
            updatedAt: any;
            gameMatchParticipantID: string;
            baseToken: string;
            quoteToken: string;
            entryPrice: number;
            size: number;
            profit?: number | null;
            side: GameMatchPositionSide;
            expiredAt?: any | null;
            targetPoint?: number | null;
            closedAt?: any | null;
            openedAt?: any | null;
            stopLoss?: number | null;
            participant: {
              __typename?: 'GameMatchParticipant';
              currency: GameMatchParticipantCurrency;
            };
          }> | null;
          match: {
            __typename?: 'GameMatch';
            id: string;
            status: GameMatchStatus;
            startTime?: any | null;
            endTime?: any | null;
            winner?: {__typename?: 'User'; nickName?: string | null} | null;
            game: {
              __typename?: 'Game';
              startVBalance: number;
              title: string;
              duration: any;
            };
            participants?: Array<{
              __typename?: 'GameMatchParticipant';
              vBalance: number;
              currency: GameMatchParticipantCurrency;
              positions?: Array<{
                __typename?: 'GameMatchPosition';
                id: string;
                createdAt: any;
                gameMatchID: string;
                quoteToken: string;
                entryPrice: number;
                side: GameMatchPositionSide;
                liquidationPrice: number;
                size: number;
                profit?: number | null;
                expiredAt?: any | null;
                openedAt?: any | null;
                closedAt?: any | null;
                targetPoint?: number | null;
                stopLoss?: number | null;
                participant: {
                  __typename?: 'GameMatchParticipant';
                  currency: GameMatchParticipantCurrency;
                  vBalance: number;
                  match: {__typename?: 'GameMatch'; id: string};
                  user: {
                    __typename?: 'User';
                    nickName?: string | null;
                    avatar?: string | null;
                    level: number;
                  };
                };
                match: {
                  __typename?: 'GameMatch';
                  id: string;
                  status: GameMatchStatus;
                  startTime?: any | null;
                  endTime?: any | null;
                };
              }> | null;
              user: {
                __typename?: 'User';
                nickName?: string | null;
                avatar?: string | null;
                id: string;
                level: number;
                wallets?: Array<{
                  __typename?: 'Wallet';
                  balance: any;
                  currency: WalletCurrency;
                }> | null;
              };
            }> | null;
          };
        } | null;
      } | null> | null;
    };
  };
};

export type GetProfileQueryVariables = Exact<{[key: string]: never}>;

export type GetProfileQuery = {
  __typename?: 'Query';
  profile: {
    __typename?: 'User';
    id: string;
    createdAt: any;
    updatedAt: any;
    isActive: boolean;
    email?: string | null;
    nickName?: string | null;
    avatar?: string | null;
    cup: any;
    exp: any;
    isSuperuser: boolean;
    isStaff: boolean;
    achievements: {
      __typename?: 'UserAchievementConnection';
      edges?: Array<{
        __typename?: 'UserAchievementEdge';
        node?: {
          __typename?: 'UserAchievement';
          id: string;
          createdAt: any;
          updatedAt: any;
          userID: string;
          achievementID: string;
          progress: number;
          isCompleted: boolean;
          completedAt?: any | null;
        } | null;
      } | null> | null;
    };
    wallets?: Array<{
      __typename?: 'Wallet';
      id: string;
      currency: WalletCurrency;
      balance: any;
      locked: any;
      createdAt: any;
      updatedAt: any;
      address?: string | null;
    }> | null;
  };
};

export type PositionsQueryVariables = Exact<{[key: string]: never}>;

export type PositionsQuery = {
  __typename?: 'Query';
  gameMatchPositions: {
    __typename?: 'GameMatchPositionConnection';
    totalCount: number;
    edges?: Array<{
      __typename?: 'GameMatchPositionEdge';
      node?: {
        __typename?: 'GameMatchPosition';
        id: string;
        createdAt: any;
        updatedAt: any;
        gameMatchID: string;
        gameMatchParticipantID: string;
        entryPrice: number;
        closePrice?: number | null;
        margin: number;
        leverage: any;
        side: GameMatchPositionSide;
        type: GameMatchPositionType;
        status: GameMatchPositionStatus;
        stopLoss?: number | null;
        targetPoint?: number | null;
        profit?: number | null;
        expiredAt?: any | null;
        openedAt?: any | null;
        closedAt?: any | null;
        quoteToken: string;
      } | null;
    } | null> | null;
  };
};

export type GetAssetsUpdatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type GetAssetsUpdatedSubscription = {
  __typename?: 'Subscription';
  assetsUpdated?: Array<{
    __typename?: 'AssetUpdate';
    id: string;
    priceUSD: number;
  } | null> | null;
};

export type GetNotificationGlobalSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type GetNotificationGlobalSubscription = {
  __typename?: 'Subscription';
  NotificationGlobal: {
    __typename?: 'Notification';
    target?: NotificationTarget | null;
    id?: string | null;
    message: string;
    createdAt?: any | null;
    action?: NotificationAction | null;
    type: NotificationType;
    event?: NotificationEvent | null;
    data?: any | null;
  };
};

export type GetNotificationMatchSubscriptionVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;

export type GetNotificationMatchSubscription = {
  __typename?: 'Subscription';
  NotificationMatch: {
    __typename?: 'Notification';
    target?: NotificationTarget | null;
    id?: string | null;
    message: string;
    createdAt?: any | null;
    action?: NotificationAction | null;
    type: NotificationType;
    event?: NotificationEvent | null;
    data?: any | null;
  };
};
